import type { PropsWithChildren } from 'react';

export const GradientBorder: React.FC<PropsWithChildren<{ selected?: boolean }>> = ({ selected, children }) => {
	return (
		<div
			className={`rounded-large ${selected ? 'elevation-elevated-selected p-[2px]' : ''}`}
			sx={{
				background: selected ? 'linear-gradient(275deg, #0139BC 2.93%, #4BAEFF 96.39%)' : undefined,
			}}
		>
			{children}
		</div>
	);
};
